import { useLocation } from 'react-router-dom'
import { useState } from 'react'

export const Topbar = () => {
	const location = useLocation()
	const [isMenuOpen, setIsMenuOpen] = useState(false)

	const isActive = (path: string) => {
		return location.pathname === path
	}

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen)
	}

	const closeMenu = () => {
		setIsMenuOpen(false)
	}

	return (
		<header className="bg-white px-4 sm:px-6 py-4 fixed w-full top-0 z-50 shadow-md">
			<div className="flex justify-between items-center max-w-screen-xl w-full mx-auto">
				{/* Logo */}
				<nav className="brand">
					<a href="/" className="flex items-center" onClick={closeMenu}>
						<img
							src={require('@assets/images/logo.png')}
							alt="Mal BOTANI SQUARE"
							className="h-10 sm:h-12 w-auto"
						/>
					</a>
				</nav>

				{/* Desktop Navigation Links */}
				<nav className="hidden md:flex items-center space-x-8">
					<a
						href="/directory"
						className={`transition-colors ${
							isActive('/directory')
								? 'bg-primary text-white px-4 py-2 rounded-lg'
								: 'text-gray-600 hover:text-primary'
						}`}
					>
						Directory
					</a>
					<a
						href="/promotion"
						className={`transition-colors ${
							isActive('/promotion')
								? 'bg-primary text-white px-4 py-2 rounded-lg'
								: 'text-gray-600 hover:text-primary'
						}`}
					>
						Promotion
					</a>
					<a
						href="/event"
						className={`transition-colors ${
							isActive('/event')
								? 'bg-primary text-white px-4 py-2 rounded-lg'
								: 'text-gray-600 hover:text-primary'
						}`}
					>
						Event
					</a>
					<a
						href="/article"
						className={`transition-colors ${
							isActive('/article')
								? 'bg-primary text-white px-4 py-2 rounded-lg'
								: 'text-gray-600 hover:text-primary'
						}`}
					>
						Article
					</a>
				</nav>

				{/* Desktop Contact Button */}
				{/* <button className="hidden md:block bg-primary hover:bg-primary-dark text-white px-6 py-2 rounded-lg transition-colors font-medium">
					Contact Us
				</button> */}

				{/* Mobile Menu Button */}
				<button
					onClick={toggleMenu}
					className="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1"
					aria-label="Toggle menu"
				>
					<span
						className={`block w-6 h-0.5 bg-gray-600 transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}
					></span>
					<span
						className={`block w-6 h-0.5 bg-gray-600 transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}
					></span>
					<span
						className={`block w-6 h-0.5 bg-gray-600 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}
					></span>
				</button>
			</div>

			{/* Mobile Menu Overlay */}
			<div
				className={`md:hidden fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ${isMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
				onClick={closeMenu}
			></div>

			{/* Mobile Menu */}
			<div
				className={`md:hidden fixed top-20 left-0 right-0 bg-white shadow-lg z-50 transition-all duration-300 ${isMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-full pointer-events-none'}`}
			>
				<nav className="px-4 py-6 space-y-4">
					<a
						href="/directory"
						className={`block py-3 px-4 rounded-lg transition-colors ${
							isActive('/directory')
								? 'bg-primary text-white'
								: 'text-gray-600 hover:text-primary hover:bg-gray-50'
						}`}
						onClick={closeMenu}
					>
						Directory
					</a>
					<a
						href="/promotion"
						className={`block py-3 px-4 rounded-lg transition-colors ${
							isActive('/promotion')
								? 'bg-primary text-white'
								: 'text-gray-600 hover:text-primary hover:bg-gray-50'
						}`}
						onClick={closeMenu}
					>
						Promotion
					</a>
					<a
						href="/event"
						className={`block py-3 px-4 rounded-lg transition-colors ${
							isActive('/event')
								? 'bg-primary text-white'
								: 'text-gray-600 hover:text-primary hover:bg-gray-50'
						}`}
						onClick={closeMenu}
					>
						Event
					</a>
					<a
						href="/article"
						className={`block py-3 px-4 rounded-lg transition-colors ${
							isActive('/article')
								? 'bg-primary text-white'
								: 'text-gray-600 hover:text-primary hover:bg-gray-50'
						}`}
						onClick={closeMenu}
					>
						Article
					</a>

					{/* Mobile Contact Button */}
					{/* <button className="w-full bg-primary hover:bg-primary-dark text-white px-6 py-3 rounded-lg transition-colors font-medium text-base">
						Contact Us
					</button> */}
				</nav>
			</div>
		</header>
	)
}
